// Opens the native Stream app on a camera invite. Production uses the
// `streambridge` scheme; local development points VITE_APP_URL_SCHEME at the
// Alpha build's `streambridge-alpha` so invites open Alpha, not the App Store
// app. A custom scheme is used rather than the https invite link because iOS
// keeps same-site universal links in Safari. The invite's host stays in the
// link (<scheme>://<host>/stream/<key>) because every released app version
// accepts that form; the short <scheme>://stream/<key> needs app 1.0.2+.
export function appUrlScheme(): string {
  return import.meta.env.VITE_APP_URL_SCHEME?.trim() || 'streambridge'
}

export function streamAppUrl(streamKey: string, eventId: string, inviteHost: string): string {
  return `${appUrlScheme()}://${inviteHost}/stream/${encodeURIComponent(streamKey)}?event=${encodeURIComponent(eventId)}`
}

/** Converts an issued `…/stream/<key>?event=<id>` invite URL, or returns null if it is not one. */
export function streamAppUrlFromInvite(inviteUrl: string): string | null {
  try {
    const url = new URL(inviteUrl)
    const match = url.pathname.match(/^\/stream\/([^/]+)\/?$/)
    const eventId = url.searchParams.get('event')
    if (!match || !eventId) return null
    return streamAppUrl(decodeURIComponent(match[1]), eventId, url.hostname)
  } catch {
    return null
  }
}
